import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '../../../assets/images/logo-eitp.png'


const _hoisted_1 = { class: "mt-50" }
const _hoisted_2 = { class: "card mb-25 border-0 rounded-0 bg-white authentication-card" }
const _hoisted_3 = { class: "card-body letter-spacing" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "text-center mb-10" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: "logo-icon",
    style: {"height":"100px"}
  })
], -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("h4", { class: "text-black fw-bold mb-0 text-center" }, "Mot de passe oublié?", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("p", { class: "mb-0 fs-md-15 fs-lg-16 text-paragraph text-center" }, [
  /*#__PURE__*/_createTextVNode(" Entrer votre adresse e-mail ci-dessous et nous "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("vous enverrons le mot de passe ")
], -1)
const _hoisted_7 = { class: "form-group mb-15 mb-sm-20" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, " Adresse email ", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("button", {
  class: "default-btn transition border-0 fw-medium text-white rounded-1 fs-md-15 fs-lg-16 d-block w-100",
  type: "submit"
}, "Envoyer", -1)
const _hoisted_10 = { class: "text-center mt-15 mt-sm-20 mt-md-25" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("i", { class: "ph-bold ph-arrow-left" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _hoisted_5,
        _hoisted_6,
        _createVNode(_component_Form, {
          ref: "forgotPasswordForm",
          onSubmit: _ctx.addForgotPassword,
          "validation-schema": _ctx.forgotPasswordSchema
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_7, [
              _hoisted_8,
              _createVNode(_component_Field, {
                name: "email",
                type: "email",
                class: "form-control shadow-none fs-md-15 text-black",
                placeholder: "Entrer l'email"
              }),
              _createVNode(_component_ErrorMessage, {
                name: "email",
                class: "text-danger"
              })
            ]),
            _hoisted_9,
            _createElementVNode("div", _hoisted_10, [
              _createVNode(_component_router_link, {
                to: "/login",
                class: "link-btn text-decoration-none text-primary fw-medium fs-md-15 fs-lg-16 position-relative"
              }, {
                default: _withCtx(() => [
                  _hoisted_11,
                  _createTextVNode("Revenir à la page de connexion ")
                ]),
                _: 1
              })
            ])
          ]),
          _: 1
        }, 8, ["onSubmit", "validation-schema"])
      ])
    ])
  ]))
}